import React, {
  Fragment,
  useState,
  useContext,
  createContext,
  useEffect,
} from "react";
import {
  Button,
  Layout,
  Menu,
  notification,
  PageHeader,
  Spin,
  Tooltip,
} from "antd";

import { Offline, PollingConfig } from "react-detect-offline";
import { ApiOutlined, LogoutOutlined } from "@ant-design/icons";
import { Observer, observer } from "mobx-react-lite";

import Text from "antd/lib/typography/Text";

import { ArrowLeft } from "react-feather";
import SubMenu from "antd/lib/menu/SubMenu";
import {
  getAntIconEquivalent,
  getCurrentUser,
  getMenuBreadCrumd,
} from "../../../Utility/helper";
import { masterPageStore as MasterPageStore } from "../store/MasterPageStore";
import { North } from "./Menu/North";
import "../styles/mastepagecontainer.css";

import { HTMLComponent } from "react-typescript-raw-html";
import { CurrentUser } from "../../Home/types/interfaces";
import { authStore } from "../../Home/store/AuthStore";
import { Navigate, useLocation } from "react-router";
import { jwtDecode } from "jwt-decode";
import { permissionStore } from "../store/PermissionStore";
const { Outlet, useNavigate } = require("react-router");
const { Link } = require("react-router-dom");
const _ = require("underscore");
const { Content, Footer, Sider } = Layout;
const { useDevice } = require("react-use-device");
// const masterstore = createContext(masterPageStore);
const masterPageStoreCtx = createContext(MasterPageStore);
const permissionStoreCtx = createContext(permissionStore);
const MasterPageContainer = observer(() => {
  const [menuCollapsed, setMenuCollapsed] = useState<boolean>(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);
  const [breadcrumb, setBreadcrumb] = useState("");
  const { isMOBILE } = useDevice();
  let navigate = useNavigate();
  const masterPageStore = useContext(masterPageStoreCtx);
  const PermissionStore = useContext(permissionStoreCtx);
  const year = (new Date()).getFullYear();
  let location = useLocation();
  useEffect(() => {
    async function Auth() {

      let currentUserData: any = localStorage.getItem("currentUser");
      if (currentUserData !== null) {

        let currentUserModifiedData: any = JSON.parse(currentUserData);
        const userToken = window.sessionStorage.getItem("qrjwt")

        if (userToken && currentUserModifiedData) {
          authStore.currentUser = currentUserModifiedData as CurrentUser;
          let tokenExpiration = jwtDecode(userToken).exp;
          let dateNow = new Date();
          if (Number(tokenExpiration) < dateNow.getTime() / 1000) {
            return <Navigate to={`/login`} state={{ from: location }} replace />
          }
        }
      } else {
        return <Navigate to={`/login`} state={{ from: location }} replace />
      }

    }
    async function loadMenu() {
      let menu = await masterPageStore.loadMenu();
      window.appMenu = menu;
    }
    Auth()
    loadMenu();
  }, []);
  const subMenuClick = async (smId: any, mId: any, url: string) => {
    try {
      let userId = getCurrentUser()?.id;
      //console.log("url", url, mId, smId);
      masterPageStore.selectedMenuId = mId;
      setBreadcrumb(url);
      await masterPageStore.setUserLastVisitedProfile(
        userId,
        smId,
        mId,
        url,
        masterPageStore.globalFacilityId,
        masterPageStore.globalFacility
      );
    } catch (error: any) {
      notification.error({
        message: "EDataBank Feedback",
        description: error.response && error.response.text,
      });
    }
  };

  const headersize = isMOBILE ? "mobileheader" : "desktopheader";
  return (
    <Layout>
      <North>
        <></>
      </North>
      <Content
        className="site-layout ms-depth-4"
        style={
          !isMOBILE
            ? {
              borderTop: "3px solid #191B40",
              margin: "20px",
              padding: "0 20px",
              paddingLeft: "0px",
              paddingBottom: "10px",
            }
            : { borderTop: "3px solid #191B40" }
        }
      >
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              {" "}
              <PageHeader
                className="site-page-header"
                onBack={() => {
                  navigate(-1);
                }}
                title={
                  <HTMLComponent
                    rawHTML={`<div class='${headersize}'>${getMenuBreadCrumd(
                      breadcrumb
                    ) ?? masterPageStore.activeTitle}</div>`}
                  ></HTMLComponent>
                }
                /*  subTitle="EDataBank" */
                backIcon={
                  <Tooltip title="Go Back">
                    {/*  <ChevronLeft style={{ marginTop: "5px", color: "red" }} /> */}
                    <ArrowLeft
                      style={{ marginTop: "5px", color: "red" }}
                      size="30"
                    />
                  </Tooltip>
                }
                style={{ fontSize: "12px" }}
              />
            </div>
          </div>
        </div>

        {/* Hamburger Menu Button for Mobile */}
        {isMOBILE && (
          <Button
            type="primary"
            icon={<span style={{ fontSize: '20px' }}>☰</span>}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              position: 'fixed',
              top: '70px',
              right: '10px',
              zIndex: 1000,
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '45px',
              height: '45px',
              padding: 0,
            }}
          />
        )}

        <Layout className="site-layout-background">
          {/* Overlay backdrop for mobile menu */}
          {isMOBILE && mobileMenuOpen && (
            <div
              onClick={() => setMobileMenuOpen(false)}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 999,
              }}
            />
          )}

          <Sider
            collapsible={!isMOBILE}
            collapsed={isMOBILE ? !mobileMenuOpen : menuCollapsed}
            className="site-layout-background"
            width={200}
            theme="light"
            breakpoint="lg"
            collapsedWidth={isMOBILE ? 0 : 50}
            onBreakpoint={(broken) => {
              //console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
              //console.log(collapsed, type);
              if (!isMOBILE) {
                setMenuCollapsed(collapsed);
              }
            }}
            style={isMOBILE ? {
              position: 'fixed',
              right: 0,
              top: 0,
              bottom: 0,
              zIndex: 1000,
              height: '100vh',
              overflow: 'auto',
            } : {}}
          >
            {masterPageStore.isMenuLoading ? (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "50vh",
                  }}
                >
                  <Spin tip="loading..." size="large"></Spin>
                </div>
              </>
            ) : (
              <Observer>
                {() => (
                  <Menu
                    theme="dark"
                    mode="inline"
                    forceSubMenuRender={true}
                    defaultOpenKeys={["1", "2", "3", "4"]}
                    defaultSelectedKeys={["1", "10"]}
                    selectedKeys={[masterPageStore.selectedSubMenuId]}
                    onClick={async (menu: any) => {
                      localStorage.setItem(
                        "selectedSubMenuId",
                        menu.keyPath[0]
                      );
                      localStorage.setItem("selectedMenuId", menu.keyPath[1]);
                      masterPageStore.selectedMenuId = menu.keyPath[1];
                      masterPageStore.selectedSubMenuId = menu.keyPath[0];
                      //console.log("menu", menu);

                      // Close mobile menu when item is clicked
                      if (isMOBILE) {
                        setMobileMenuOpen(false);
                      }

                      // mainStore.menuSelectedKey = menu.keyPath[0];
                      //  mainStore.menuOpenKey = menu.keyPath[1]; */
                    }}
                  >
                    {masterPageStore.selectedMenu.map((menu: any) => (
                      <SubMenu
                        title={
                          <span>
                            {getAntIconEquivalent(menu.menuIcon, menuCollapsed)}
                            <Text style={{ color: "inherit" }}>
                              {menu.menu}
                            </Text>
                          </span>
                        }
                        key={menu.menuId}
                      // style={{display:`${menu.renderMenu?"block":"none"}`}}
                      >
                        {menu.subMenus.map((sm: any) => (

                          PermissionStore.getPermissions(sm.url).canView && (

                            <Menu.Item
                              key={sm.subMenuId}
                              style={{ cursor: "pointer" }}

                              onClick={async () => {
                                await subMenuClick(
                                  sm.subMenuId,
                                  menu.menuId,
                                  sm.url
                                );
                              }}
                            >
                              <Link to={sm.url ? sm.url : "#"}>{sm.name}</Link>
                            </Menu.Item>
                          )
                        ))}
                      </SubMenu>
                    ))}
                  </Menu>
                )}
              </Observer>
            )}

            {/* Logout Button at Bottom - Mobile Only */}
            {isMOBILE && (
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: '16px',
                  borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                  backgroundColor: '#001529',
                }}
              >
                <Button
                  type="text"
                  icon={<LogoutOutlined style={{ color: '#ff4d4f', fontSize: '18px' }} />}
                  onClick={() => {
                    // Clear session and navigate to login
                    window.sessionStorage.clear();
                    localStorage.clear();
                    navigate('/login');
                  }}
                  style={{
                    width: '100%',
                    color: '#ff4d4f',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    fontWeight: 500,
                    height: '40px',
                  }}
                >
                  <span style={{ marginLeft: '8px' }}>Logout</span>
                </Button>
              </div>
            )}
          </Sider>
          <Content>
            <div
              className="site-layout-background"
              style={{
                paddingTop: "0px",
                marginLeft: "5px",
              }}
            >
              <Outlet />
            </div>
          </Content>
        </Layout>
      </Content>
      <Footer style={{ textAlign: "center" }}>
        ESOCS Data Bank ©{year} All Rights Reserved
      </Footer>
      <Offline
        polling={

          {
            interval: 300000,
            url: "https://ipv4.icanhazip.com"
          } as PollingConfig
        }
        onChange={(args: any) => {
          if (args === true) {
            notification.success({
              message: `Connected `,
              description: "successfully connected to the internet",
              placement: "bottomRight",
            });
          } else {
            notification.warning({
              message: `Not Connected `,
              description:
                "it looks like you're not connected to the internet or temporarily disconnected,please check your internet connection",
              placement: "bottomRight",
              icon: <ApiOutlined style={{ color: "red" }} />,
            });
          }
        }}
      ></Offline>
    </Layout>
  );
});

export default MasterPageContainer;
